import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { AiFillHome, AiFillMessage, AiOutlineMenuUnfold } from "react-icons/ai";
import { BsFillPersonFill, BsFillHandbagFill } from "react-icons/bs";
import { HiOutlineMailOpen } from "react-icons/hi";

import "./Navbar.css";

const Navbar = (props) => {
  const [isToggled, setIsToggled] = useState();

  return (
    <>
      <div
        className={isToggled ? "body_click" : ""}
        onClick={() => setIsToggled(!isToggled)}
      ></div>
      <nav className={isToggled ? "nav menu_toggled" : "nav"}>
        <div className="menu_toggle" onClick={() => setIsToggled(!isToggled)}>
          <span className="menu_toggle_icon">
            <AiOutlineMenuUnfold />
          </span>
        </div>
        <ul className="activateLi">
          <li className={props.activeLi1}>
            <NavLi pageTo="/" menuTxt="Home" menuIcon={<AiFillHome />} />
          </li>
          <li className={props.activeLi2}>
            <NavLi
              pageTo="/about"
              menuTxt="About"
              menuIcon={<BsFillPersonFill />}
            />
          </li>
          <li className={props.activeLi3}>
            <NavLi
              pageTo="/projects"
              menuTxt="Projects"
              menuIcon={<BsFillHandbagFill />}
            />
          </li>
          <li className={props.activeLi4}>
            <NavLi
              pageTo="/contact"
              menuTxt="Contact"
              menuIcon={<AiFillMessage />}
            />
          </li>
          <li className={props.activeLi5}>
            <NavLi
              pageTo="/blog"
              menuTxt="Blog"
              menuIcon={<HiOutlineMailOpen />}
            />
          </li>
        </ul>
        <Outlet />
      </nav>
    </>
  );
};

const NavLi = (props) => {
  return (
    <Link to={props.pageTo}>
      <div className="hover_box"></div>
      <div className="menu_icon">{props.menuIcon}</div>
      <h4 className="menu_text">{props.menuTxt}</h4>
    </Link>
  );
};

export default Navbar;
